import React from 'react';
import PropTypes from 'prop-types';
import Toast from './Toast';
import './ToastContainer.css';

/**
 * Container para múltiplos toasts
 */
const ToastContainer = ({ toasts, onClose }) => {
  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          visible={toast.visible}
          duration={toast.duration}
          onClose={() => onClose?.(toast.id)}
        />
      ))}
    </div>
  );
};

ToastContainer.propTypes = {
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      message: PropTypes.string.isRequired,
      type: PropTypes.oneOf(['success', 'error', 'info', 'warning']),
      visible: PropTypes.bool.isRequired,
      duration: PropTypes.number
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired
};

export default ToastContainer;
